import { Component, OnInit, OnDestroy, Testability } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserSession } from '../shared/user-session';
import { UpdateLobService } from '@mem-shared/update-lob.service';


declare var oktaLogin: any;
declare var oktaLoginP2PInbound: any;
declare var oktaWidgetHide: any;
declare var oktaWidgetShow: any;
declare var getLobFromUrl:any;

@Component({
  selector: 'mem-okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.scss']
})
export class OktaLoginComponent implements OnInit {

  lob: any;
  oktaLob : any;
  oktaRef: any;
  target: boolean;
  
  constructor(private route: ActivatedRoute,
    private router: Router,
    public userSession: UserSession,
    private updateLobService: UpdateLobService) {  }

  ngOnInit() {

    this.route.queryParams
      .subscribe(params => {
        if (params.target)
        {
          this.target = true;
        }
       }
    );

    if (!window['OktaLob'])
    {
      //let check = this.target ? this.oktaP2PInbound() : this.okta();
      this.route.queryParams
      .subscribe(params => {
         this.lob = '';
          if (params.lob) {
            this.lob = params.lob.toUpperCase();
              window['OktaLob'] = this.lob;
              //this.oktaP2PInbound();
            }
          else {
             let str = decodeURIComponent(window.location.href);
             let redirectUrl = str.substr(str.indexOf("?fromURI=") + 9);
            let relaystate = this.getParameterByName("RelayState", redirectUrl);
            let tokens = relaystate.split('/');
            window['OktaLob'] = tokens[5].toUpperCase();
            // this.getLobFromUrl();
          }
    });
    
      // window['OktaLob']?.this.updateLobService.setLob(window['OktaLob']);
      // window['OktaLob']?.this.userSession.setLocalStorageItem('lob',  window['OktaLob'] );
      this.updateLobService.setLob(window['OktaLob']);
      this.userSession.setLocalStorageItem('lob',  window['OktaLob'] );
      let check = this.target ? this.oktaP2PInbound() : this.okta();
    }
    else
    {
       new oktaWidgetShow(window['SignInRef']);
    }
    this.lob = this.userSession.getLocalStorageItem('lob');
  }
  registerNow() {
    this.router.navigate(['/registration/step2/FHIRUSER'], { queryParams: { LOB: this.userSession.getLocalStorageItem('lob') } });
  }
  goToRecovery()
  {
    this.router.navigate(['/accountRecovery/step1'], { queryParams: { LOB: this.userSession.getLocalStorageItem('lob')} });

  }

okta()
{
   new oktaLogin();
}
oktaP2PInbound()
{
   new oktaLoginP2PInbound();
}
getLobFromUrl()
{
    new getLobFromUrl();
}
 
ngOnDestroy() {
    new oktaWidgetHide(window['SignInRef']);
}
  getParameterByName(name, url) {
    let results;
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
}





// WEBPACK FOOTER //
// ./src/app/okta-login/okta-login.component.ts